import { routeMeta, usePageMeta } from "../../lib/usePageMeta";

const RESOURCES = [
  { icon: "📘", title: "Documentation", body: "Guides for ingestion, extraction review, clause playbooks, and compliance evidence." },
  { icon: "🎓", title: "Guides & tutorials", body: "Step by step walkthroughs for onboarding your organization and first contracts." },
  { icon: "📰", title: "Blog", body: "Product updates and perspectives on governed AI for regulated industries." },
  { icon: "📞", title: "Support", body: "Reach our team for onboarding help, security reviews, and procurement questions." },
];

export function Resources() {
  usePageMeta(routeMeta("/resources"));
  return (
    <section className="section">
      <div className="container">
        <div className="section__head">
          <h1>Resources for running governed AI</h1>
          <p>Everything you need to get value from Odingard Studio.</p>
        </div>
        <div className="feature-grid">
          {RESOURCES.map((r) => (
            <div className="feature" key={r.title}>
              <div className="feature__icon" aria-hidden="true">
                {r.icon}
              </div>
              <h3>{r.title}</h3>
              <p>{r.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
